<template>
  <div class="product-feature-badge">
    <div
      v-for="badge in badges"
      :key="badge.featureId"
      class="product-feature-badge__label"
      :style="{ '--badge-color': badge.color }"
    >
      <div class="product-feature-badge__ear"></div>
      <span class="product-feature-badge__text"> {{ badge.text }} </span>
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  badges: any[];
}
defineProps<Props>();
</script>

<style lang="scss" scoped>
.product-feature-badge {
  position: absolute;
  display: flex;
  right: 16px;
  top: -12px;
  width: fit-content;
  height: 27px;
  z-index: 11;
  border-top-right-radius: 10px;
  column-gap: 16px;

  &__text {
    font-size: var(--text-sm-font-size);
    line-height: var(--text-sm-line-height);
    text-transform: uppercase;
  }

  &__label {
    position: relative;
    color: white;
    font-size: 16px;
    border-top-right-radius: 10px;
    display: inline-block;
    padding: 2px 12px;
    background-color: var(--badge-color);
  }

  &__ear {
    position: absolute;
    top: 0;
    left: -12px;
    width: 12px;
    height: 12px;
    border-top-left-radius: 10px;
    overflow: hidden;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 12px;
      height: 12px;
      background-color: rgba(0, 0, 0, 0.15);
      border-top-right-radius: 10px;
      z-index: 13;
    }

    &::after {
      content: '';
      position: absolute;
      top: 0;
      width: 100%;
      height: 100%;
      background-color: var(--badge-color);
      border-top-left-radius: 100%;
      z-index: 12;
    }
  }
}
</style>
